import { render, staticRenderFns } from "./LoadRevenueCost.vue?vue&type=template&id=b776959c"
import script from "./LoadRevenueCost.vue?vue&type=script&lang=js"
export * from "./LoadRevenueCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports